export enum SendPinCodeResult {
    InvalidId,
    UnrecognisedError,
    Success,
    ApplicationApproved,
    ApplicationDeclined
}



// WEBPACK FOOTER //
// ./src/models/send-pin-code-result.ts